import React from "react"
import SmiWidget from "../SmiWidget"

export function ToPad({isDesktop, isFull}) {
    return (
        <div className="to-pad">
            <SmiWidget blockId={isFull ? (isDesktop ? '30210' : '30242') : (isDesktop ? '30171' : '30186')}/>
        </div>
    )
}
